import { render, staticRenderFns } from "./CostPricesRules.vue?vue&type=template&id=77437c16"
import script from "./CostPricesRules.vue?vue&type=script&lang=js"
export * from "./CostPricesRules.vue?vue&type=script&lang=js"
import style0 from "./CostPricesRules.vue?vue&type=style&index=0&id=77437c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports